export const LogoutIcon = ({ className }: { className: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
    >
        <path d="M19.8531 12.3531C20.0469 12.1594 20.0469 11.8406 19.8531 11.6469L15.8531 7.64687C15.6594 7.45312 15.3406 7.45312 15.1469 7.64687C14.9531 7.84062 14.9531 8.15938 15.1469 8.35313L18.2937 11.5H9.5C9.225 11.5 9 11.725 9 12C9 12.275 9.225 12.5 9.5 12.5H18.2937L15.1469 15.6469C14.9531 15.8406 14.9531 16.1594 15.1469 16.3531C15.3406 16.5469 15.6594 16.5469 15.8531 16.3531L19.8531 12.3531ZM9.5 6C9.775 6 10 5.775 10 5.5C10 5.225 9.775 5 9.5 5H6.5C5.11875 5 4 6.11875 4 7.5V16.5C4 17.8813 5.11875 19 6.5 19H9.5C9.775 19 10 18.775 10 18.5C10 18.225 9.775 18 9.5 18H6.5C5.67188 18 5 17.3281 5 16.5V7.5C5 6.67188 5.67188 6 6.5 6H9.5Z" />
    </svg>
);
